import useDarkMode from '@/utils/hooks/utils/useDarkMode';

type QuoraIconProps = React.ComponentPropsWithRef<'svg'>;

export function QuoraIcon({ ...restProps }: QuoraIconProps) {
    const { isDarkMode } = useDarkMode();

    if (isDarkMode()) {
        return (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...restProps}>
                <g clipPath="url(#clip0_115_4027)">
                    <path
                        d="M7.3799 0.948295C9.83885 -0.0710334 12.5675 -0.241135 15.134 0.464915C17.7005 1.17096 19.9583 2.71283 21.5498 4.84646C23.1414 6.98009 23.9759 9.5836 23.9212 12.2449C23.8665 14.9062 22.9258 17.4732 21.248 19.5397L23.6576 21.9622C24.3898 22.6984 23.8676 23.9527 22.8304 23.9527L12.1199 23.9627C12.0186 23.9639 11.9172 23.9639 11.8159 23.9627H11.7959C9.04319 23.9242 6.38799 22.9375 4.27821 21.1689C2.16842 19.4004 0.73317 16.9583 0.214564 14.2546C-0.304042 11.5509 0.125736 8.7511 1.4314 6.32743C2.73706 3.90377 4.83871 2.0046 7.3818 0.950295L7.3799 0.948295ZM14.7016 5.37629C13.8292 5.00299 12.8915 4.80651 11.9426 4.79825C10.9938 4.78999 10.0527 4.9701 9.17396 5.32816C8.29522 5.68622 7.49627 6.2151 6.8234 6.88416C6.15054 7.55321 5.61714 8.34915 5.2541 9.22584C4.89106 10.1025 4.70561 11.0426 4.70849 11.9914C4.71137 12.9403 4.90252 13.8792 5.27087 14.7537C5.63922 15.6281 6.17744 16.4208 6.85435 17.0858C7.53127 17.7508 8.33341 18.2748 9.2143 18.6275C10.9673 19.3334 12.9281 19.3188 14.6704 18.5869C16.4128 17.8551 17.7958 16.4651 18.5189 14.7191C19.2421 12.9732 19.2469 11.0124 18.5322 9.26289C17.8176 7.51343 16.4413 6.11673 14.7026 5.37639L14.7016 5.37629Z"
                        fill="white"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_115_4027">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }

    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}>
            <g clipPath="url(#clip0_115_4069)">
                <path
                    d="M7.3799 0.948295C9.83885 -0.0710334 12.5675 -0.241135 15.134 0.464915C17.7005 1.17096 19.9583 2.71283 21.5498 4.84646C23.1414 6.98009 23.9759 9.5836 23.9212 12.2449C23.8665 14.9062 22.9258 17.4732 21.248 19.5397L23.6576 21.9622C24.3898 22.6984 23.8676 23.9527 22.8304 23.9527L12.1199 23.9627C12.0186 23.9639 11.9172 23.9639 11.8159 23.9627H11.7959C9.04319 23.9242 6.38799 22.9375 4.2782 21.1689C2.16842 19.4004 0.733166 16.9583 0.21456 14.2546C-0.304046 11.5509 0.125732 8.7511 1.4314 6.32743C2.73706 3.90377 4.8387 2.0046 7.3818 0.950295L7.3799 0.948295ZM14.7016 5.37629C13.8292 5.00299 12.8914 4.80651 11.9426 4.79825C10.9937 4.78999 10.0527 4.9701 9.17395 5.32816C8.29521 5.68622 7.49627 6.2151 6.8234 6.88416C6.15054 7.55321 5.61713 8.34915 5.25409 9.22584C4.89106 10.1025 4.70561 11.0426 4.70848 11.9914C4.71136 12.9403 4.90251 13.8792 5.27086 14.7537C5.63921 15.6281 6.17744 16.4208 6.85435 17.0858C7.53126 17.7508 8.3334 18.2748 9.2143 18.6275C10.9673 19.3334 12.9281 19.3188 14.6704 18.5869C16.4127 17.8551 17.7958 16.4651 18.5189 14.7191C19.2421 12.9732 19.2468 11.0124 18.5322 9.26289C17.8176 7.51343 16.4413 6.11673 14.7026 5.37639L14.7016 5.37629Z"
                    fill="#B92B27"
                />
            </g>
            <defs>
                <clipPath id="clip0_115_4069">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
